import { ChakraText as Text } from "@airhelp/react-ui-components";

export interface ErrorComponentProps {
  text: string;
}

const ErrorComponent = ({ text }: ErrorComponentProps) => (
  <Text p={4} bg="tomato" color="white" borderRadius="md">
    {text}
  </Text>
);

export default ErrorComponent;
